import { ArticleHeading2, Button, Spinner } from '@cian/ui-kit';
import { ArrowDown16 } from '@cian/ui-kit/prev';
import { SelectMobileModal } from '@cian/ui-kit/select/components/SelectMobile/SelectMobileModal';
import * as React from 'react';

import * as styles from './TopMenuMobile.css';
import { ERoute, TRoute } from '../../types/route';
import { ETopMenuStatus } from '../../types/topMenuStatus';

type TTopMenuMobileProps = {
  currentRoute: TRoute;
  isChangeListVisible: boolean;
  selectedCount: number;
  onChangeRoute(route: TRoute): void;
  onChangeListClick(): void;
  status: ETopMenuStatus;
};

const MenuItems: { [key in ERoute]: string } = {
  [ERoute.Messages]: 'Все сообщения',
  [ERoute.Unread]: 'Непрочитанные',
  [ERoute.Spam]: 'Заблокированные',
  [ERoute.Archive]: 'Архив',
};

const MENU_OPTIONS = Object.entries(MenuItems).map(([value, label]) => ({ value, label }));

export const TopMenuMobile: React.VFC<TTopMenuMobileProps> = ({
  currentRoute,
  onChangeRoute,
  isChangeListVisible,
  onChangeListClick,
  selectedCount,
  status,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleCloseModal = React.useCallback(() => setIsOpen(false), []);
  const handleOnChange = React.useCallback(
    (route: TRoute) => {
      onChangeRoute(route);
      setIsOpen(false);
    },
    [onChangeRoute],
  );

  const leftView = React.useMemo(() => {
    switch (status) {
      case ETopMenuStatus.Offline:
        return (
          <span className={styles['heading']}>
            <ArticleHeading2>Ожидание сети</ArticleHeading2>
            <Spinner size={16} />
          </span>
        );
      case ETopMenuStatus.ChangeList:
        return (
          <span className={styles['heading']}>
            <ArticleHeading2>
              {selectedCount > 0 ? `Выбрано ${selectedCount}` : MenuItems[currentRoute]}
            </ArticleHeading2>
          </span>
        );
      case ETopMenuStatus.NotAuthorized:
        return (
          <span className={styles['heading']}>
            <ArticleHeading2>{MenuItems[ERoute.Messages]}</ArticleHeading2>
          </span>
        );
      case ETopMenuStatus.Loading:
      default:
        return (
          <Button size="M" theme="fill_white_primary" onClick={() => setIsOpen(!isOpen)} color="black100">
            {
              /* Это хак, но тянуть все вспомогательные стили кнопки дорого */
              (
                <span className={styles['button']}>
                  {MenuItems[currentRoute]}
                  {status === ETopMenuStatus.Loading ? <Spinner size={16} /> : <ArrowDown16 color="primary_100" />}
                </span>
              ) as unknown as React.ReactText
            }
          </Button>
        );
    }
  }, [status, selectedCount, currentRoute, isOpen]);

  return (
    <div data-name="TopMenuMobile" className={styles['container']}>
      {leftView}
      {isChangeListVisible && (
        <Button
          size="M"
          theme="fill_white_primary"
          onClick={onChangeListClick}
          disabled={status === ETopMenuStatus.Loading}
        >
          {[ETopMenuStatus.ChangeList, ETopMenuStatus.Loading].includes(status) ? 'Готово' : 'Изменить'}
        </Button>
      )}
      <SelectMobileModal
        options={MENU_OPTIONS}
        open={isOpen}
        onClose={handleCloseModal}
        value={currentRoute}
        onChange={handleOnChange}
        title=""
      />
    </div>
  );
};
